import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import {
  getCurrentUserId,
  getNotificationsByUserId,
} from "./store/StoreSelectors";
import { RootState } from "./store/store";
import {
  deleteNotifiedNotifications,
  Notifications,
} from "./store/NotificationsSlice";

const StyledToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container {
    width: 60%;
  }
  .Toastify__toast {
    background-color: #ee2e24db;
    color: #fff;
  }

  .Toastify__toast-body {
    font-size: large;
    text-align: center;
  }
`;

const StyledLink = styled(Link)`
  color: #fff;
  text-decoration: underline;
`;

const GlobalAlertNotificationsStacks = () => {
  const { t: translate } = useTranslation(["common"]);
  const dispatch = useDispatch();
  const currentUserId = useSelector(getCurrentUserId);

  const notifications =
    useSelector((state: RootState) =>
      getNotificationsByUserId(currentUserId)(state)
    ) || [];

  const SnackbarMessage = useCallback(
    (notification: Notifications) => (
      <Trans
        i18nKey={translate("common:apiResponse.downloadPdfReadyForDownload")}
        values={{
          profileName: notification.metadata?.profileName,
          internalId: notification.metadata?.internalId
            ? `(${notification.metadata?.internalId})`
            : "",
        }}
        components={{
          anchor: (
            <StyledLink
              to={`/protect/profile/${notification.metadata?.profileId}`}
            />
          ),
        }}
      />
    ),
    [translate]
  );

  useEffect(() => {
    notifications.forEach((notification) => {
      toast.success(SnackbarMessage(notification), {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        transition: Slide,
        toastId: notification.id,
      });
      dispatch(deleteNotifiedNotifications(notification.id));
    });
  }, [notifications, SnackbarMessage, dispatch]);

  return <StyledToastContainer limit={3} icon={false} />;
};

export default GlobalAlertNotificationsStacks;
